import React, { memo, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';

import { isIP } from 'validator';

import PopupMenu from '../popupmenu';
import DataContext from '../../data/data-context.js';

const useStyles = makeStyles(theme => ({
    root: {
    },
    popperOverride: {
        backgroundColor: theme.palette.background.selectionAlt,
        '&::hover': {
            backgroundColor: theme.palette.background.selectionAlt,
        },
    },
}));

function AssetSelector ({
    value,
    onChange,
    componentclass,
    placement = 'bottom-start',
    ...rest
}) {
    const classes = useStyles();
    const { assets, sensorNames } = useContext(DataContext);
    const [assetList, setAssetList] = useState([]);

    const handleSelectAsset = a => {
        onChange({ target: { value: a.ip } });
    };

    useEffect(() => {
        // normalize, dedup, combine assets + sensors
        // remove items mapped to a hostname because filters must use ips
        // finally sort
        const sensorsmap = Object.values(sensorNames)
            .reduce((a, c) => ({ ...a, [c.host]: { ...c, ip: c.host, name: c.name || c.host } }), {});
        const list = Object.values({ ...assets, ...sensorsmap })
            .filter(a => (isIP(a.ip, 4) || isIP(a.ip, 6)))
            .sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
        setAssetList(list);
    }, [assets, sensorNames]);

    return (
        <React.Fragment>
            <TextField
                { ...rest}
                value={value}
                onChange={onChange}
                InputProps={{
                    endAdornment:
                        <InputAdornment position="end">
                            <PopupMenu
                                tooltip="select from assets"
                                aria-label="select from assets"
                                placement={placement}
                                className={classes.popperOverride}
                                items={assetList}
                                itemkey='ip'
                                itemTitle='name'
                                onSelect={handleSelectAsset}
                                icon={<FolderSpecialIcon
                                    className={componentclass}
                                    fontSize="small"/>
                                }
                                size='small'
                                getInfo={d => d.ip}
                                zIndex={1500}/>
                        </InputAdornment>,
                }}
            />
        </React.Fragment>
    );
}

AssetSelector.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    componentclass: PropTypes.string,
    placement: PropTypes.string,
};

export default memo(AssetSelector);
